module.exports = __webpack_public_path__ + "static/media/current_cycle_left.dbc5a162.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/current_cycle_left.svg
// module id = 103
// module chunks = 0